import { MenuItem, Select, SelectProps, Stack, StackProps } from "@mui/material";
import MuiPagination from "@mui/material/Pagination";
import { Text, TextProps } from "@imminently/react/ui/core/text";

// export const PatientPagination = (props: any) => {
//   const apiRef = useGridApiContext();
//   const paginationModel = useGridSelector(apiRef, gridPaginationModelSelector);

//   return (
//     <Pagination
//       {...props}
//       showFirstButton
//       showLastButton
//       color="primary"
//       page={paginationModel.page + 1}
//     />
//   );
// };

export interface PaginationDisplayedRowsProps {
  from: number;
  to: number;
  count: number;
  page: number;
}

const DisplayedRows = ({ from, to, count }: PaginationDisplayedRowsProps) => {
  const label = `Showing ${from}-${to} of ${count} entries`;
  return <Text>{label}</Text>;
};

// const RowsPerPage = ({ children, ...props }: TextProps) => <Text {...props}>{children ?? "Rows per page:"}</Text>;

const RowsPerPage = ({ label, options, ...props }: { label: string; options: number[] } & SelectProps) => {
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Text>{label ?? "Rows per page:"}</Text>
      <Select {...props}>
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </Stack>
  );
};



// a composable pagination component that allows for re-ordering of the pagination slots
// or even adding new ones

export const Pagination = ({ children, ...props }: StackProps) => {
  // should probably apply context or pass stuff through here
  return (
    <Stack direction="row" {...props}>
      {children}
    </Stack>
  );
};

Pagination.RowsPerPage = RowsPerPage;
Pagination.DisplayedRows = DisplayedRows;
Pagination.Actions = MuiPagination;

export default Pagination;